import { connect } from 'react-redux'
import CommentsTable from './comments-table'
import {
  getCommentsList,
  getCommentsPagination,
  getFetchRequest
} from '../../../../../stores/comments/comments.selectors'
import { fetchComments } from '../../../../../stores/comments/comments.actions'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const comments = getCommentsList(state)
  const pagination = getCommentsPagination(state)
  return {
    pending: getFetchRequest(state).pending,
    comments: comments,
    noComments: !comments.length,
    pagination
  }
}

const mapDispatchToprops = (dispatch, { match }) => ({
  onPageChange: ({ selected }) =>
    dispatch(fetchComments(match.params.id, { page: selected })).catch(
      errorHandler
    )
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToprops
  )(CommentsTable)
)
